import { http as taskHttp } from './http'

export const publishTask = data => taskHttp.post('/user/publishTask', data)

export const getTaskEstimate = params => taskHttp.get('/user/taskEstimate', { params })

export const getMyPublishedTasks = userId => taskHttp.get('/user/myPublishedTasks', { params: { userId } })

export const getPublishedTaskDispatchProgress = (taskId, userId) => taskHttp.get(`/user/publishedTasks/${taskId}/dispatchProgress`, { params: { userId } })

export const redispatchPublishedTask = (taskId, data) => taskHttp.post(`/user/publishedTasks/${taskId}/redispatch`, data)

export const updatePublishedTaskSubsidy = (taskId, data) => taskHttp.post(`/user/publishedTasks/${taskId}/subsidy`, data)

export const updatePublishedTask = data => taskHttp.post('/user/updatePublishedTask', data)

export const cancelPublishedTask = data => taskHttp.post('/user/cancelPublishedTask', data)

export const deletePublishedTask = data => taskHttp.post('/user/deletePublishedTask', data)

export const republishCancelledTask = data => taskHttp.post('/user/republishCancelledTask', data)
